import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const ChapterApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['chapter', 'get', webinarId], (api) => api.chapter.get(webinarId), options),
    update: (options?: BaseApiMutationOptions<ApiClient['chapter']['update']>) => apiMutationOptions((api) => api.chapter.update, options)
};
